import { render } from "./textData.vue?vue&type=template&id=186a9e48"
import script from "./textData.vue?vue&type=script&lang=js"
export * from "./textData.vue?vue&type=script&lang=js"

import "./textData.vue?vue&type=style&index=0&id=186a9e48&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__